const StatusChangeTooltip = ({
  statusItem,
  statusChange = () => {},
  setActiveTooltip,
  isActive,
  itemId,
  colorMap = {
    info: {
      dot: "bg-sky-500",
      hover: "hover:bg-sky-100",
      bg: "bg-sky-100",
      text: "text-sky-700",
      activeText: "text-sky-800",
    },
    indigo: {
      dot: "bg-indigo-500",
      hover: "hover:bg-indigo-100",
      bg: "bg-indigo-100",
      text: "text-indigo-700",
      activeText: "text-indigo-800",
    },
    warning: {
      dot: "bg-amber-500",
      hover: "hover:bg-amber-100",
      bg: "bg-amber-100",
      text: "text-amber-700",
      activeText: "text-amber-800",
    },
    success: {
      dot: "bg-emerald-500",
      hover: "hover:bg-emerald-100",
      bg: "bg-emerald-100",
      text: "text-emerald-700",
      activeText: "text-emerald-800",
    },
    danger: {
      dot: "bg-rose-500",
      hover: "hover:bg-rose-100",
      bg: "bg-rose-100",
      text: "text-rose-700",
      activeText: "text-rose-800",
    },
    stone: {
      dot: "bg-stone-500",
      hover: "hover:bg-stone-100",
      bg: "bg-stone-100",
      text: "text-stone-700",
      activeText: "text-stone-800",
    },
  }
}) => {
  
  const color = colorMap[statusItem.color] || colorMap.info;

  return (
    <div
      key={statusItem.state}
      onClick={() => {
        if (!isActive) {
          statusChange({ id: itemId, status: statusItem.state });
        }
        setActiveTooltip(null);
      }}
      className={`flex items-center justify-between gap-2 px-4 py-2 text-sm cursor-pointer
        ${isActive ? `${color.bg} ${color.activeText} font-semibold` : color.text}
        ${color.hover}`}
    >
      <div className="flex items-center gap-2">
        <span className={`w-2 h-2 rounded-full ${color.dot}`} />
        {statusItem.state[0].toUpperCase() + statusItem.state.slice(1)}
      </div>

      {isActive && <i className={`fa-solid fa-check text-xs ${color.text}`} />}
    </div>
  );
};
export default StatusChangeTooltip;
